var map = {
	"./ar.json": [
		64214,
		4214
	],
	"./en.json": [
		17429,
		7429
	],
	"./hi.json": [
		10773,
		773
	],
	"./ta.json": [
		26163,
		6163
	],
	"./te.json": [
		37633,
		7633
	],
	"./ur.json": [
		21453,
		1453
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 41131;
module.exports = webpackAsyncContext;